import { log, LogTag } from "services/logger";
import { isControllerChromecastFromState } from "services/player/controllers/service/helpers";

export function onIsConnectedChanged({ value: isConnected }: cast.framework.RemotePlayerChangedEvent<boolean>) {
    if(!isControllerChromecastFromState()) return;

    log.info({ tags: [LogTag.Chromecast], code: "web-210804-1332", msg: `onIsConnectedChanged: ${isConnected}` });
}
